export default [{
    path: 'producerList',
    name: {list:['数字产地','产地','产地管理','产地列表']},
    component: () => import('@/views/producer/producerList.vue')
},{
    path: 'producerAdd',
    name: {list:['数字产地','产地','产地管理','产地列表','新增产地'],title:'新增产地'},
    component: () => import('@/views/producer/producerEdit.vue')
},{
    path: 'producerEdit',
    name: {list:['数字产地','产地','产地管理','产地列表','编辑产地'],title:'编辑产地'},
    component: () => import('@/views/producer/producerEdit.vue')
},{
    path: 'producerDetails',
    name: {list:['数字产地','产地','产地管理','产地列表','产地详情'],title:'产地详情'},
    component: () => import('@/views/producer/producerDetails.vue')
},{
    path: 'accountManage',
    name: {list:['数字产地','产地','产地管理','账号管理']},
    component: () => import('@/views/producer/accountManage.vue')
}]